/**
 * Environment reading helpers: the display formatting of CO2 / humidity / temperature readings and the node type
 * that carries the environment sensors.
 */
/** Node type that carries the environment sensors (temperature, humidity). */
export const NODE_TYPE_WITH_ENVIRONMENT_SENSORS = 3;
export const hasEnvironmentReadings = (row) => row.nodeTypeCode === NODE_TYPE_WITH_ENVIRONMENT_SENSORS;
/** Shown instead of a reading the API has no value for. */
export const NO_READING = "--";
export const formatTemperatureReading = (value) => value == null ? NO_READING : `${value.toFixed(1)} °C`;
export const formatHumidityReading = (value) => value == null ? NO_READING : `${value}%`;
export const formatCo2Reading = (value) => value == null ? NO_READING : `${value} ppm`;
